import { Transaction } from '../swagger/api';
import ProductItemsStore from '../stores/product-stores/ProductItemsStore';

export default function getProductOrReferenceLabel(
  transaction: Transaction,
  productItemsStore: ProductItemsStore
): string {
  const product = transaction.identifierId
    ? productItemsStore.findProductFromId(transaction.identifierId)
    : null;
  return product?.reference || transaction.identifierReference || transaction.vehiclePlate || '';
}
